import { ComponentPropsWithRef } from "react";

export const DownloadIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M23.4913 35.4533L12.9087 24.8708C12.6286 24.5906 12.6286 24.135 12.9087 23.8548L14.7962 21.9673C15.0764 21.6872 15.5321 21.6872 15.8122 21.9673L23.4923 29.6474C23.7725 29.9276 24.2282 29.9276 24.5084 29.6474L32.1884 21.9673C32.4686 21.6872 32.9243 21.6872 33.2045 21.9673L35.0919 23.8537C35.3721 24.1339 35.3721 24.5896 35.0919 24.8698L24.5094 35.4523C24.2292 35.7325 23.7735 35.7325 23.4933 35.4523L23.4913 35.4533Z"
      fill="currentColor"
    />
    <path
      d="M25.3342 8H22.6657C22.2689 8 21.9473 8.32165 21.9473 8.71843V32.3405C21.9473 32.7373 22.2689 33.0589 22.6657 33.0589H25.3342C25.7309 33.0589 26.0526 32.7373 26.0526 32.3405V8.71843C26.0526 8.32165 25.7309 8 25.3342 8Z"
      fill="currentColor"
    />
    <path
      d="M39.2816 35.8793H8.71843C8.32165 35.8793 8 36.2009 8 36.5977V39.2662C8 39.6629 8.32165 39.9846 8.71843 39.9846H39.2816C39.6783 39.9846 40 39.6629 40 39.2662V36.5977C40 36.2009 39.6783 35.8793 39.2816 35.8793Z"
      fill="currentColor"
    />
  </svg>
);
